<router-outlet name="mc-sidebar"></router-outlet>
<div class="mapping-cont-ini-" style="margin-bottom: 56px;">
  <h2 class="mat-display-2">Mapa curricular<br><small>Visualice la totalidad y el detalle de nuestro currículo</small>
  </h2>
  <ul class="mapping-splash">
    <li>
      <img src="./assets/mapping-1.png" class="mapping-splash-img"><br>
      Busque metas y genere mapas curriculares</li>
    <li>
      <img src="./assets/mapping-3.png" class="mapping-splash-img"><br>
      Conecte metas y visualice conexiones</li>
    <li>
      <img src="./assets/mapping-2.png" class="mapping-splash-img"><br>
      Cree rápidamente metas y unidades</li>
  </ul>
  <div style="display: flex; justify-content: center;"><button mat-raised-button color="primary"
      (click)="abrirBusqueda()">
      Empezar
    </button>
  </div>
</div>
<h2 class="mat-h2 mapping-cont-ini-">Mapas curriculares preestablecidos</h2>
<div *ngIf="fullData$ | async as fullData" class="mapping-cont-ini">
  <mat-form-field appearance="outline" class="full-width">
    <mat-label i18n="label filtro | label de filtro por palabra@@labelFiltroPalabra">Filtrar por palabra</mat-label>
    <input matInput (keyup)="textFilter($event.target.value)">
  </mat-form-field>
  <div class="mapping-links-cont">
    <h3 class="mat-h3" i18n="mapa grado | label mapa curricular por grados@@labelMapaGrados">Mapa curricular por grados
    </h3>
    <div>
      <ul>
        <ng-container *ngFor="let curso of fullData.cursos">
          <li class="mapping-preset-link" style="display: inline-block;">
            <a [routerLink]="['/estudio', 'mapa-curricular', 'materias', 0, 'cursos', curso.id]">
              {{curso.nombre}}
            </a>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
  <mat-divider style="margin: 32px 0;"></mat-divider>
  <div class="mapping-links-cont">
    <h3 class="mat-h3" i18n="mapa areas | label mapa curricular por areas@@labelMapaAreas">Mapa curricular por áreas y
      materias</h3>
    <div>
      <ul class="links-columnas avoid-break" style="margin-top: 0;">
        <ng-container *ngFor="let area of fullData.areas">
          <li style="margin-top: 0; margin-bottom: 4px;">
            <mat-label class="mapping-preset-cat">{{area.nombre}}</mat-label>
            <ul style="display: inline; margin: 0 0 0 0; padding: 0 0 0 0;">
              <ng-container *ngFor="let materia of area.materias">
                <li class="mapping-preset-link">
                  <a [routerLink]="['/estudio', 'mapa-curricular', 'materias', materia.id, 'cursos', 0]">
                    {{materia.nombre}}
                  </a>
                </li>
              </ng-container>
            </ul>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
</div>
